// export const baseURL = '';
export const baseURL = '/api/rest/s1';
